import { render, staticRenderFns } from "./r-worker-kind-dialog.vue?vue&type=template&id=46930e34"
import script from "./r-worker-kind-dialog.vue?vue&type=script&lang=js"
export * from "./r-worker-kind-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46930e34')) {
      api.createRecord('46930e34', component.options)
    } else {
      api.reload('46930e34', component.options)
    }
    module.hot.accept("./r-worker-kind-dialog.vue?vue&type=template&id=46930e34", function () {
      api.rerender('46930e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker-kind/r-worker-kind-dialog.vue"
export default component.exports